<template>
  <div class="container" v-if="!displayLogin">
    <form accept-charset="UTF-8" role="form" @submit.stop.prevent="handleSubmit">
      <h1>{{ title }}</h1>
      <p class="text-muted">{{ msg }}</p>
      <p class="text-muted">{{ this.$passwordRequirements }}</p>
      <div class="alert alert-success" v-show="successMessage">
        {{ successMessage }}
      </div>
      <div class="alert alert-danger" v-show="errorMessage">
        {{ errorMessage }}
      </div>

      <fieldset>
        <div class="input-group mb-3">
          <span class="input-group-addon"><i class="icon-user"></i></span>
          <input name="username" class="form-control" placeholder="Customer ID" type="text" v-model="username" required min="1"
                 pattern="[0-9]+"
                 oninvalid="setCustomValidity('Numeric Customer ID required (not your name or email). Spaces and non-numeric characters are not allowed')"
                 oninput="setCustomValidity('')"
                 v-validate.initial="'required'"
                 data-vv-as="Customer ID"
                 :disabled="disableAllInputs">
          <div v-show="validate_errors.has('username')" class="invalid-feedback">{{ validate_errors.first('username') }}</div>
        </div>

        <div class="input-group mb-4">
          <span class="input-group-addon"><i class="icon-key"></i></span>
          <input name="code" class="form-control" placeholder="code" type="text" v-model="code" min="6"
                 v-validate="'required|digits:6'"
                 data-vv-as="code"
                 :disabled="disableAllInputs">
          <div v-show="validate_errors.has('code')" class="invalid-feedback">{{ validate_errors.first('code') }}</div>
        </div>

        <div class="input-group mb-4">
          <span class="input-group-addon"><i class="icon-lock"></i></span>
          <input name="newPassword" class="form-control" placeholder="new password" type="password" v-model="newPassword" min="8"
                 v-validate="'required|min:8|contains_alpha_lower|contains_alpha_upper|contains_number'"
                 data-vv-as="password"
                 :disabled="disableAllInputs">
          <div v-show="validate_errors.has('newPassword')" class="invalid-feedback">{{ validate_errors.first('newPassword') }}</div>
        </div>

        <div class="input-group mb-4">
          <span class="input-group-addon"><i class="icon-lock"></i></span>
          <input name="newPasswordConfirmation" class="form-control" placeholder="confirm password" type="password"
                 v-model="newPasswordConfirmation" min="1"
                 v-validate="'required|confirmed:newPassword'"
                 data-vv-as="confirm password"
                 :disabled="disableAllInputs">
          <div v-show="validate_errors.has('newPasswordConfirmation')" class="invalid-feedback">{{ validate_errors.first('newPasswordConfirmation') }}</div>
        </div>

        <input class="btn btn-primary px-4" type="submit" value="Save Password"
               :disabled="protectedUI || !formIsValid || disableAllInputs">

        <input class="btn px-4" @click="resendCode" type="button" value="Get New Code">
        <router-link to="/" class="btn btn-block">Cancel</router-link>
      </fieldset>
    </form>
  </div>
</template>

<script>
  export default {
    name: 'PasswordConfirmation',
    data: () => ({
      displayLogin: false,
      title: 'Enter New Password',
      msg: 'You should have received a code via email or text.  Please provide that code and your Customer ID to set your password.',
      errorMessage: null,
      successMessage: null,
      disableAllInputs: false,
      protectedUI: false,
      username: '',
      code: '',
      newPassword: '',
      newPasswordConfirmation: ''
    }),
    methods: {
      handleSubmit () {
        // Remove alert boxes
        this.successMessage = null
        this.errorMessage = null

        this.protectedUI = true
        this.$store.dispatch('confirmPassword', {
          username: this.username,
          code: this.code,
          newPassword: this.newPassword

        }).then(() => {
          this.disableAllInputs = true
          this.successMessage = 'Successfuly confirmed'

          this.$store.dispatch('authenticateUser', {
            username: this.username,
            password: this.newPassword
          }).then((result) => {
            if (result.userConfirmationNecessary) {
              this.$router.push({ name: 'PasswordChallenge', params: { forwarded: true } })
            } else {
              this.newPassword = ''
              this.successMessage = 'Successfuly signed in'
              this.$router.push({ path: '/' })
            }
          }).catch((err) => {
            console.log(err)
            this.$raven.captureException(err)
            this.errorMessage = err.message
            this.protectedUI = false
          })
        }).catch((err) => {
          this.$raven.captureException(err)
          this.errorMessage = err.message
          this.protectedUI = false
        })
      },
      assignUser (user) {
        if (user === '' || user === undefined) {
          return false
        }
        this.username = user
        return true
      },
      authenticated () {
        return this.$store.getters.cognitoAuthenticated
      },
      resendCode () {
        this.$router.push({ name: 'ForgotPassword', query: { u: this.username } })
      }
    },
    computed: {
      formIsValid () {
        return Object.keys(this.fields).every(key => this.fields[key].valid)
      }
    },
    created: function () {
      // if query param 'u' provided, automatically add that to username
      // and submit form
      let username = this.$route.query.u
      this.assignUser(username)
    }
  }
</script>

<style scoped>
  .input-group {
    flex-wrap: wrap;
    flex-direction: row;
  }
  .input-group input.form-control {
    width: 70%;
  }
</style>



// WEBPACK FOOTER //
// src/components/auth/PasswordConfirmation.vue?5ed856f5